var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',{staticClass:"p-4",class:_vm.valuePositive ? 'success--text' : 'error--text'},[_c('v-icon',{staticClass:"mb-1 ml-2",attrs:{"size":"12","color":_vm.valuePositive ? 'success' : 'error'}},[_vm._v(" "+_vm._s(_vm.valuePositive ? "$increase" : "$decrease"))]),_vm._v(" "+_vm._s(_vm.value)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }